// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-custom":"Breadcrumb_breadcrumb-custom__20M45","vnrBreadcrumb":"Breadcrumb_vnrBreadcrumb__2Ymik","breadcrumbItem":"Breadcrumb_breadcrumbItem__3vvSK"};